import React from 'react'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'

import { Text, TEXT_VARIANT_LIGHT, Flex, HelpIcon } from 'mailup-web-components'
import styled from '@emotion/styled'

import {
  SENDING_ABORT_REASON_CONTENTVETTING,
  SENDING_ABORT_REASON_GRACEPERIOD,
  SENDING_ABORT_REASON_INVALIDPEC,
  SENDING_ABORT_REASON_NOSEND,
  SENDING_ABORT_REASON_UNKNOWN,
  SENDING_STATUS_ABORTED,
  SENDING_STATUS_ENDING,
  SENDING_STATUS_FAILED,
  SENDING_STATUS_STOPPING,
  SENDING_STATUS_NOT_DISTURB
} from 'Constants/index'

const PhaseCell = ({ status, abortReason, startingUp, withAnimation }) => {
  const intl = useIntl()
  let stringId = ''
  let stringIdTootlip = ''

  if ([SENDING_STATUS_STOPPING, SENDING_STATUS_ENDING].includes(status)) {
    stringId = 'Load.Schedulation.FinalPhaseOfSending'
  }

  switch (status) {
    case SENDING_STATUS_FAILED:
      stringId = 'Load.Schedulation.StatusFailed'
      break

    case SENDING_STATUS_ABORTED:
      stringId = 'Load.Schedulation.SendStatusAborted'
      break

    case SENDING_STATUS_NOT_DISTURB:
      stringId = 'Load.Schedulation.SendStatusDndInfo'
      break
  }

  switch (abortReason) {
    case SENDING_ABORT_REASON_GRACEPERIOD:
    case SENDING_ABORT_REASON_NOSEND:
      stringIdTootlip = 'Load.Schedulation.AdministrativeAbortedSendingsTooltip'
      break
    case SENDING_ABORT_REASON_CONTENTVETTING:
      stringIdTootlip = 'Load.Schedulation.BlacklistAbortedSendingsTooltip'
      break
    case SENDING_ABORT_REASON_INVALIDPEC:
      stringIdTootlip = 'Load.Schedulation.InvalidPec'
      break
    case SENDING_ABORT_REASON_UNKNOWN:
      stringIdTootlip = 'Load.Schedulation.GenericAbortedSendingsTooltip'
      break
  }

  return (
    <Flex padding='24px 16px' data-mu-test='sending-status'>
      {!!stringId && (
        <Text
          variant={TEXT_VARIANT_LIGHT}
          className={
            withAnimation &&
            status !== SENDING_STATUS_NOT_DISTURB &&
            'with-animation'
          }
        >
          {intl.formatMessage({ id: stringId })}{' '}
        </Text>
      )}

      {stringIdTootlip && <HelpIcon data-tip={stringIdTootlip} />}

      {startingUp && (
        <StyledItalicText
          variant={TEXT_VARIANT_LIGHT}
          className={withAnimation && 'with-animation'}
        >
          {intl.formatMessage({ id: 'Load.Schedulation.StartingSending' })}
        </StyledItalicText>
      )}
    </Flex>
  )
}
export default PhaseCell

PhaseCell.propTypes = {
  status: PropTypes.any,
  abortReason: PropTypes.any,
  startingUp: PropTypes.any,
  withAnimation: PropTypes.bool
}

const StyledItalicText = styled(Text)`
  font-style: italic !important;
`
